<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :d="path" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'chevron-animated',

  props: {
    reverse: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      progress: 0, // 0 ~ 1
    };
  },

  computed: {
    direction() {
      return this.reverse ? 1 : -1;
    },

    animationProgress() {
      return !Number.isInteger(this.progress);
    },

    halfProgress() {
      return this.progress > .5 ? 1 - this.progress : this.progress * 2;
    },

    path() {
      return `M${3 - this.halfProgress*3} ${6 + this.progress * 4}L8 ${11 - this.progress * 6}L${13 + this.halfProgress*3} ${6 + this.progress*4}`;
    },
  },

  watch: {
    reverse() {
      !this.animationProgress && this.updateProgress();
    }
  },

  mounted() {
    if (this.reverse) this.updateProgress();
  },

  methods: {
    updateProgress() {
      this.progress += this.direction * .1;
      if (this.progress >= 1 || this.progress <= 0 ) {
        this.progress = this.progress > 1 ? 1 : 0;
        return;
      }
      requestAnimationFrame(this.updateProgress);
    },
  },
};
</script>
